import React from 'react';

interface FilterIconProps {
  size?: number;
}

const FilterIcon: React.FC<FilterIconProps> = ({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 5h16l-6 7v6l-4 2v-8z" />
    </svg>
  );
};

export default FilterIcon;
